import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "w-100 py-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_SelectUser = _resolveComponent("SelectUser")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ExpenseReportAddress = _resolveComponent("ExpenseReportAddress")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.activeUploadDocuments)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          style: {"background-color":"transparent"},
          elevation: "0",
          class: "oss-card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, {
              class: _normalizeClass(
                    !_ctx.$vuetify.display.mobile
                        ? 'title font-weight-regular justify-space-between d-flex'
                        : 'title font-weight-regular pa-1'
                )
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.wizardStepTitle), 1),
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_avatar, {
                      key: 0,
                      color: "primary lighten-2",
                      class: "subheading white--text",
                      size: "24",
                      textContent: _toDisplayString(_ctx.wizardStep)
                    }, null, 8, ["textContent"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_v_window, {
              modelValue: _ctx.wizardStep,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.wizardStep) = $event)),
              touchless: "",
              style: _normalizeStyle(!_ctx.$vuetify.display.mobile ? 'min-height: 27vh;' : '')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "pa-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.expenseReport.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expenseReport.name) = $event)),
                            placeholder: "Nom de la note de frais",
                            "single-line": "",
                            autofocus: _ctx.$vuetify.display.smAndUp,
                            outlined: "",
                            "data-cy": "ExpenseReportWizard-name",
                            density: "compact"
                          }, null, 8, ["modelValue", "autofocus"])
                        ]),
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_FreeTag, {
                            company: _ctx.companyId,
                            splitUserPartitions: true,
                            companyTags: _ctx.allCompanyTags,
                            onOnTagsChanged: _ctx.onTagsChanged
                          }, null, 8, ["company", "companyTags", "onOnTagsChanged"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "pa-0" }, {
                      default: _withCtx(() => [
                        (_ctx.wizardStep === 2)
                          ? (_openBlock(), _createBlock(_component_SelectUser, {
                              key: 0,
                              ref: "selectUser",
                              modelValue: _ctx.expenseReportUser,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expenseReportUser) = $event)),
                              companyId: _ctx.companyId,
                              type: 'NATURAL_PERSON',
                              actions: _ctx.actions,
                              autoSelect: true,
                              height: "50vh",
                              "data-cy": "ExpenseReportWizard-selectUser"
                            }, null, 8, ["modelValue", "companyId", "actions"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "pa-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_date_picker_wrapper, {
                          locale: "fr-FR",
                          modelValue: _ctx.dateValue,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateValue) = $event)),
                          width: "100%",
                          landscape: !_ctx.$vuetify.display.mobile,
                          class: "elevation-0",
                          color: "gradient",
                          scrollable: "",
                          "data-cy": "ExpenseReportWizard-date"
                        }, null, 8, ["modelValue", "landscape"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "pa-0" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("shared.amountOfFiles", _ctx.expenseReport.documents.length || 0, {
                                count: _ctx.expenseReport.documents.length || 0,
                            })) + " ", 1),
                        _createVNode(_component_v_list, { lines: "two" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expenseReport.documents, (document, i) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: i,
                                class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 py-2 oss-list-item'
                                        : 'mb-2 pa-2 oss-list-item'
                                )
                              }, {
                                prepend: _withCtx(() => [
                                  (document.signedUrl)
                                    ? (_openBlock(), _createBlock(_component_v_menu, {
                                        key: 0,
                                        "open-on-hover": "",
                                        "offset-x": "",
                                        location: "end"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_img, _mergeProps({
                                            src: document.signedUrl,
                                            height: "50px",
                                            ref_for: true
                                          }, props), null, 16, ["src"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_img, {
                                                src: document.signedUrl,
                                                width: "800px"
                                              }, null, 8, ["src"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (document.travelExpense)
                                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                                            _createTextVNode("$directions_car")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_icon, {
                                    icon: "$delete_outline",
                                    onClick: ($event: any) => (_ctx.deleteCategory(document))
                                  }, null, 8, ["onClick"])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    (!document.travelExpense)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_select_filled, {
                                              rounded: "",
                                              modelValue: document.accountableAccount.name,
                                              "onUpdate:modelValue": [($event: any) => ((document.accountableAccount.name) = $event), ($event: any) => (_ctx.categoryChange(document))],
                                              items: _ctx.categories,
                                              placeholder: "Catégorie",
                                              label: "Catégorie",
                                              "single-line": "",
                                              outlined: "",
                                              class: "pt-0",
                                              density: "compact",
                                              "item-title": "text"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : (_openBlock(), _createBlock(_component_v_list_item_title, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getCategoryText(document.accountableAccount)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "text-left"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.getDateFormated(
                                                        document.date || _ctx.expenseReport.date,
                                                    )), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "text-right"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(document.grossAmount
                                                        ? _ctx.newCommonFormatCurrency(
                                                              document.grossAmount,
                                                              undefined,
                                                          )
                                                        : "-"), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "text-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => {
                                        _ctx.openCameraOnly
                                            ? _ctx.openCamera()
                                            : (_ctx.activeUploadDocuments = true);
                                        _ctx.activeTravelExpense = false;
                                    }),
                                  class: "btn mr-2",
                                  "data-cy": "expenseReport-import-document",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                    _createTextVNode("Nouvelles factures")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_btn, {
                                  class: "btn ml-2",
                                  rounded: "",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => {
                                        _ctx.currentTravelExpenseDocument = null;
                                        _ctx.wizardStep = 5;
                                    }),
                                  "data-cy": "expenseReport-new-travelExpense",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode("Frais kilométriques")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  class: "pb-2",
                  value: 5
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ExpenseReportAddress, {
                      travelExpense: _ctx.currentTravelExpense,
                      isOwner: true,
                      year: _ctx.year,
                      onOrigin: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setOrigin($event))),
                      onDestination: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDestination($event)))
                    }, null, 8, ["travelExpense", "year"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "style"]),
            (!_ctx.actions)
              ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    (_ctx.wizardStep >= 1 && _ctx.wizardStep <= 3)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          rounded: "",
                          style: {"color":"#fff"},
                          class: "btn mr-0",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.nextStep()), ["prevent"])),
                          disabled: !_ctx.expenseReport.name,
                          "data-cy": "expenseReport-next",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode(" Suivant ")
                          ])),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.wizardStep === 4)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          rounded: "",
                          style: {"color":"#fff"},
                          class: "btn mr-0",
                          disabled: 
                        !_ctx.expenseReport.name ||
                        !_ctx.expenseReport.documents ||
                        !_ctx.expenseReport.documents.length
                    ,
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.save(true)), ["prevent"])),
                          "data-cy": "expenseReport-create",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode(" Créer ")
                          ])),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.wizardStep === 5 && !_ctx.currentTravelExpenseDocument)
                      ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                          key: 2,
                          style: {"float":"right"},
                          rounded: "",
                          disabled: !_ctx.commonEnableModification || !_ctx.currentTravelExpenseAmount,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => {
                        _ctx.newTravelExpense();
                        _ctx.wizardStep = 4;
                    }),
                          "data-cy": "expenseReport-add-travelExpense",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode("Ajouter ")
                          ])),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_UploadDocuments, {
          key: 1,
          ref: "uploadDocument",
          disableAutoOpenFileDialog: true,
          companyId: _ctx.companyId,
          documentType: 'EXPENSE_REPORT_DOCUMENT',
          actions: _ctx.actions,
          ownerId: _ctx.expenseReportUser.id,
          onBack: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onUDBack())),
          onNewDocument: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onNewDocument($event))),
          onFilesUploaded: _cache[13] || (_cache[13] = ($event: any) => (_ctx.filesUploaded()))
        }, null, 8, ["companyId", "actions", "ownerId"]))
  ]))
}